// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3354":"5dba74f3","8109":"598f7a64"}[chunkId] + ".chunk.css";
};